import { isDefined } from './type';

export const randomInt = (max: number) =>
  Math.floor(Math.random() * Math.floor(max));
export const uuid = () => Math.random().toString(36).slice(2);
export const range = (
  start: number,
  stop?: number,
  step?: number
): Array<number> =>
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-nested-ternary
  isDefined(stop)
    ? isDefined(step)
      ? Array(Math.ceil((stop - start) / step))
          // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-3 arguments, but got 0.
          .fill()
          .map(
            (_, i) =>
              i * (step || 1) +
              /* technically unnecessary, but flow complains */
              start
          )
      : range(start, stop, stop >= start ? 1 : -1)
    : range(0, start);
